import React, { useState } from 'react'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from "axios";
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { FaEyeSlash } from "react-icons/fa";
import { FaEye } from "react-icons/fa";

import Cookies from 'js-cookie';
import { useNavigate } from 'react-router-dom'

const SuperAdminSignIn = () => {
  const[loading,setLoading]=useState(false)
  const [viewPassword, setViewPassword] = useState(false);

  const navigate = useNavigate();
  const validationSchema = Yup.object().shape({
    password: Yup.string()
    .min(8, 'Password must be at least 8 characters long')
    .matches(/[a-z]/, 'Password must contain at least one lowercase letter')
    .matches(/[A-Z]/, 'Password must contain at least one uppercase letter')
    .matches(/[0-9]/, 'Password must contain at least one number')
    .matches(/[!@#$%^&*(),.?":{}|<>]/, 'Password must contain at least one special character')
    .required('Password is required'),
    email: Yup.string().email('Invalid email format').required('Email is required'),
  });
  const initialValues = {
    email: '',
    password: '',
  };
  const updateViewPassword=()=>{
    setViewPassword(!viewPassword)
  }

  const adminLogIn=async(values)=>{
    setLoading(true)
    try{
      const userData={ 
        email:values.email,
        password:values.password,
      }
      const response = await axios.post(
        "https://bankdata.inclineanalytics.com/api/users/super-admin-login",userData
      );
      if(response.data.success){
        const data = response.data.data;
        const {userRole} = data
        if(userRole==="ADMIN"){
          toast.success(response.data.message)
          localStorage.setItem("role",response.data.data.userRole)
          Cookies.set('jwt_token', response.data.data.token, { expires: 30,secure:true});
        setTimeout(()=>{
          navigate('/super-admin/dashboard')
          setLoading(false)
        },2000)} 
        else{
          console.error("Invalid Credentials");
          toast.error("Invalid Credentials, Try again");
          setLoading(false)
      }
      }else{
        console.error("Invalid Credentials");
        toast.error("Invalid Credentials, Try again");
        setLoading(false)
      }
    }
  catch (error) {
    console.error("Error loging in:", error);
    toast.error(error.response.data.message)
    setLoading(false);
  }
}

  return (
    <div className ="bg-[#001f3f] max-h-[100vh] h-screen overflow-y-auto p-2 text-[#fff]">
      <ToastContainer/>
      <div className="flex flex-col justify-center items-center">
        <div>
            <a href="/" className="inline-block">
                <img src="https://www.inclineanalytics.com/wp-content/uploads/2020/04/Incline-Analytics5-01.png" alt="Incline Analytics Logo" style={{ width: "150px", height: "auto" }} />
            </a>
        </div>
        <div className="lg:space-x-16 mt-5 lg:mt-0 h-[80vh] flex flex-col lg:flex-row lg:justify-center lg:items-center">
            <div className="lg:w-1/2 -mt-10 mb-5">
                <h1 className='font-bold text-5xl leading-tight'>
                Leverage your data <br />
                <span className='text-[#ff6f61]'>elevate&nbsp;your business</span>
                </h1>
                <p className='text-lg leading-normal mt-5' style={{ fontSize: "18px", lineHeight: "1.5", marginTop: "20px" }}>
                We specialize in advanced analytics tailored for multi-site healthcare companies. We equip our clients with insights and tools to stimulate revenue growth, improve operational efficiencies, streamline cost management, and fortify managerial controls for scalable operations. Through customized analytics solutions, we offer valuable insights that support strategic decision-making, optimize overall performance, and fortify investor relations.
                </p>
            </div>
            <div className="lg:w-1/2">
                <div className="max-w-md mx-auto">
                    <Formik
                        initialValues={initialValues}
                        validationSchema={validationSchema}
                        onSubmit={adminLogIn}
                    >
                        {({isSubmitting }) => (
                        <Form className="bg-white p-8 rounded-lg shadow-md">
                            <div className="mb-4 h-[100px] min-w-[200px]">
                            <label htmlFor="email" className="block text-left text-gray-700 text-lg font-bold mb-2">
                                Email
                            </label>
                            <Field
                                type="email"
                                id="email"
                                name="email"
                                className="mt-1 block w-full p-2 pl-4 border rounded-lg text-black border-[#ff6f61] focus:border-[#ff6f61] focus:border-[3px] focus:outline-none"
                            />
                            <ErrorMessage name="email" component="div" className=" text-left ml-2 text-red-500 text-sm mt-1" />
                            </div>

                            <div className="mb-4 h-[100px] min-w-[200px]">
                            <label htmlFor="password" className="block text-left text-gray-700 text-lg font-bold mb-2">
                                Password
                            </label>
                            <div className="mt-1 w-full flex p-2 pl-4 border rounded-lg text-black border-[#ff6f61] focus-within:border-[3px]">
                            <Field
                                type={`${viewPassword? 'text':'password'}`}
                                id="password"
                                name="password"
                                className="text-black w-full focus:outline-none"
                            />
                            <button type='button' className="text-black mr-2 text-xl" onClick={updateViewPassword}>{viewPassword? <FaEye />:<FaEyeSlash />}</button>
                            </div>
                            <ErrorMessage name="password" component="div" className="text-left ml-2 text-red-500 text-sm mt-1" />
                            </div>

                            <button
                            type="submit"
                            className="w-full bg-[#ff6f61] mt-4 text-white py-2 px-4 rounded-md focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                            disabled={isSubmitting}
                            >
                            {loading? 
                              <div className="flex justify-center items-center">
                                <div className="spinner" style={{
                                  border: "2px solid rgba(255, 255, 255, 0.3)",
                                  borderRadius: "50%",
                                  borderTop: "2px solid #fff",
                                  width: "20px",
                                  height: "20px",
                                  animation: "spin 1s linear infinite",
                                  marginRight: "10px"
                                }} />
                                Logging in...
                              </div>:"Login"}
                            </button>
                            <div className="flex justify-end items-center ">
                            <button type="button" onClick={()=>{
                              navigate('/forgot-password')
                            }} className="block text-blue-900 hover:underline mt-5 text-right">Forgotten password?</button>
                            
                            </div>
                            </Form>
                        )}
                    </Formik>
                </div>
            </div>
        </div>
      </div>
    </div>
  )
}
export default SuperAdminSignIn

